// extracted by mini-css-extract-plugin
export var container = "_s9-0";
export var inputWidth = "_s9-1";